var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"heading"},[_vm._v(" Partners ")])])],1),_c('b-row',[_c('b-col',[_c('b-img',{attrs:{"src":"/images/partners.png","fluid":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }